import { useComponentRegistry } from '@bem-react/di';
import React from 'react';

import { TRegion } from 'client/common/types';
import cn from 'utils/cn';

import './index.css';

export interface IRegionSwitcherProps {
    tld: string;
    regions: TRegion[];
}

const cnRegionSwitcher = cn('region-switcher');

function RegionSwitcher({ tld, regions }: IRegionSwitcherProps) {

    function wrapRegion({ url, name }: TRegion) {
        return {
            value: name,
            content:
    <a className={cnRegionSwitcher('link')} href={url}>
        <div className={cnRegionSwitcher('link-text')}>{name}</div>
    </a>
        };
    }

    const { Select } = useComponentRegistry('lego');

    const currentName = regions.find(region => region.tld === tld)!.name;
    const options = regions.filter(({ name }) => name !== currentName).map(wrapRegion);

    return (
        <div className={cnRegionSwitcher()}>
            <Select
                options={options}
                view="classic"
                size="m"
                theme="normal"
                placeholder={currentName}
                />
        </div>
    );
}

export default RegionSwitcher;
